// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    /* ==========================================
   GLOBAL DARK THEME
   Este archivo controla TODA la app en modo oscuro
   ========================================== */

/* 1. Fondo global de la aplicación */
body.dark-theme {
  background-color: #141414;
  color: #e0e0e0;
}

/* 2. Sobreescribir el Layout Principal y Sidebar (Ant Design) */
.dark-theme .ant-layout,
.dark-theme .ant-layout-sider,
.dark-theme .ant-menu {
  background-color: #1f1f1f !important;
  color: #e0e0e0;
}

.dark-theme .ant-layout-sider {
  border-right: 1px solid #303030;
}

.dark-theme .ant-menu-item-selected {
  background-color: #112a1d !important;
  color: #4ade80 !important;
}

/* 3. Tus estilos específicos de Configuración (Movidos aquí) */
.dark-theme .settings-page-container { background-color: #141414; border-color: #303030; }
.dark-theme .settings-sidebar { background-color: #1f1f1f; border-right-color: #303030; }
.dark-theme .settings-sidebar-header { border-bottom-color: #303030; }
.dark-theme .settings-sidebar-header h3,
.dark-theme .settings-header-text h2,
.dark-theme .settings-card-title { color: #ffffff; }
.dark-theme .settings-menu-item { color: #a6a6a6; }
.dark-theme .settings-menu-item:hover { background-color: #262626; }
.dark-theme .settings-menu-item.active { background-color: #112a1d; color: #4ade80; border-color: #1a4d2e; }
.dark-theme .settings-menu-item.active .anticon { color: #4ade80; }
.dark-theme .settings-main-content { background-color: #141414; }
.dark-theme .settings-header-icon { background-color: #112a45; color: #177ddc; }
.dark-theme .settings-header-text p { color: #8c8c8c; }
.dark-theme .settings-card { background-color: #1f1f1f; border-color: #303030; box-shadow: none; }
.dark-theme .settings-section-header { border-bottom-color: #303030; }
.dark-theme .payment-method-box { background-color: #1f1f1f; border-color: #303030; }
.dark-theme .payment-method-box:hover { border-color: #434343; }
.dark-theme .payment-method-header { border-bottom-color: #303030; }
.dark-theme .payment-method-header span[style*="font-weight: 600"] { color: #ffffff !important; }
.dark-theme .payment-details-grid { background-color: #141414; border-color: #434343; }
.dark-theme .payment-detail-item { color: #e0e0e0; }
.dark-theme .image-upload-wrapper { background-color: #141414; border-color: #434343; }
.dark-theme .image-upload-wrapper:hover { border-color: #177ddc; }

/* 4. Aquí irás agregando cualquier otro módulo en el futuro */
/* .dark-theme .modulo-facturas { ... } */



/* ==========================================
   SISTEMA DE TEMA OSCURO GLOBAL (dark.css)
   ========================================== */

/* Base Global */
body.dark-theme {
  background-color: #141414 !important;
  color: #ffffff !important;
}

/* --- MÓDULO CONFIGURACIÓN EN MODO OSCURO --- */
.dark-theme .settings-page-container {
  background-color: #141414;
}

.dark-theme .settings-sidebar {
  background-color: #1f1f1f;
  border-right-color: #303030;
}

.dark-theme .settings-sidebar-header {
  border-bottom-color: #303030;
}

.dark-theme .settings-sidebar-header h3,
.dark-theme .settings-header-text h2,
.dark-theme .settings-card-title {
  color: #ffffff;
}

.dark-theme .settings-menu-item {
  color: #a6a6a6;
}

.dark-theme .settings-menu-item:hover {
  background-color: #262626;
}

.dark-theme .settings-menu-item.active {
  background-color: #112a1d; 
  color: #4ade80;
  border-color: #1a4d2e;
}

.dark-theme .settings-menu-item.active .anticon {
  color: #4ade80;
}

.dark-theme .settings-main-content {
  background-color: #141414;
}

.dark-theme .settings-header-icon {
  background-color: #112a45;
  color: #177ddc;
}

.dark-theme .settings-header-text p {
  color: #8c8c8c;
}

.dark-theme .settings-card {
  background-color: #1f1f1f;
  border-color: #303030;
  box-shadow: none;
}

.dark-theme .settings-section-header {
  border-bottom-color: #303030;
}

.dark-theme .payment-method-box {
  background-color: #1f1f1f;
  border-color: #303030;
}

.dark-theme .payment-method-box:hover {
  border-color: #434343;
}

.dark-theme .payment-method-header {
  border-bottom-color: #303030;
}

.dark-theme .payment-method-header span[style*="font-weight: 600"] {
  color: #ffffff !important;
}

.dark-theme .payment-details-grid {
  background-color: #141414;
  border-color: #434343;
}

.dark-theme .payment-detail-item {
  color: #e0e0e0;
}

.dark-theme .image-upload-wrapper {
  background-color: #141414;
  border-color: #434343;
}

.dark-theme .image-upload-wrapper:hover {
  border-color: #177ddc;
}

.dark-theme .empty-text {
  color: #a6a6a6;
}

/* --- REGLAS ANT DESIGN PARA MODO OSCURO --- */

/* Labels de Formularios */
.dark-theme .ant-form-item-label > label {
  color: #ffffff !important; 
}

/* Inputs, Textareas y Selects */
.dark-theme .ant-input,
.dark-theme .ant-select-selector,
.dark-theme .ant-input-textarea {
  background-color: #141414 !important;
  color: #ffffff !important;
  border-color: #434343 !important;
}

/* Placeholders */
.dark-theme .ant-input::placeholder,
.dark-theme .ant-select-selection-placeholder {
  color: #595959 !important;
}

/* Iconos de Selects */
.dark-theme .ant-select-arrow,
.dark-theme .ant-select-clear {
  color: #a6a6a6 !important;
}

/* Modales */
.dark-theme .ant-modal-content,
.dark-theme .ant-modal-header {
  background-color: #1f1f1f !important;
}
.dark-theme .ant-modal-title {
  color: #ffffff !important;
}
.dark-theme .ant-modal-close {
  color: #a6a6a6 !important;
}
.dark-theme .ant-modal-close:hover {
  color: #ffffff !important;
  background-color: #303030 !important;
}

/* Divisores */
.dark-theme .ant-divider-inner-text {
  color: #ffffff;
}
.dark-theme .ant-divider-dashed {
  border-color: #434343;
}

/* Responsividad Móvil */
@media (max-width: 768px) {
  .dark-theme .settings-sidebar {
    border-bottom-color: #303030;
  }
}
/* ==========================================
   COMPONENTES GENERALES DE ANTD (MODO OSCURO)
   ========================================== */

/* 1. TARJETAS (Cards) */
.dark-theme .ant-card {
  background-color: #1f1f1f !important;
  border-color: #303030 !important;
}

.dark-theme .ant-card-head {
  border-bottom-color: #303030 !important;
}

.dark-theme .ant-card-head-title,
.dark-theme .ant-card-head-title .ant-typography {
  color: #ffffff !important;
}

/* 2. INPUTS Y CAMPOS DE TEXTO */
.dark-theme .ant-input,
.dark-theme .ant-input-affix-wrapper,
.dark-theme .ant-input-search-button {
  background-color: #141414 !important;
  border-color: #434343 !important;
  color: #ffffff !important;
}

.dark-theme .ant-input::placeholder,
.dark-theme .ant-input-affix-wrapper input::placeholder {
  color: #8c8c8c !important;
}

.dark-theme .ant-input-search .ant-input-group-addon button {
  background-color: #262626 !important;
  border-color: #434343 !important;
  color: #ffffff !important;
}

/* 3. ETIQUETAS DE FORMULARIO Y TEXTO GENERAL */
.dark-theme label,
.dark-theme .ant-form-item-label > label,
.dark-theme .ant-typography {
  color: #e0e0e0 !important;
}

/* 4. DIVIDERS (LÍNEAS DIVISORAS) */
.dark-theme .ant-divider {
  border-top-color: #303030 !important;
}

/* 5. POPCONFIRM / MODALES */
.dark-theme .ant-popover-inner,
.dark-theme .ant-popconfirm-inner-content {
  background-color: #1f1f1f !important;
  color: #ffffff !important;
}
.dark-theme .ant-popover-message-title {
  color: #ffffff !important;
}
/* ==========================================
   16. DRAWERS (PANELES LATERALES) Y MODALES (PORTALES)
   ========================================== */

/* Contenedores principales del Drawer */
.dark-theme .ant-drawer-content,
.dark-theme .ant-drawer-header,
.dark-theme .ant-drawer-body,
.dark-theme .ant-drawer-footer {
  background-color: #1f1f1f !important;
  border-bottom-color: #303030 !important;
  border-top-color: #303030 !important;
  color: #e0e0e0 !important;
}

/* Título y botón de cerrar del Drawer */
.dark-theme .ant-drawer-title {
  color: #ffffff !important;
}
.dark-theme .ant-drawer-close {
  color: #a6a6a6 !important;
}
.dark-theme .ant-drawer-close:hover {
  color: #ffffff !important;
  background-color: #303030 !important;
}

/* Footer del Modal (Faltaba oscurecer la línea divisoria inferior) */
.dark-theme .ant-modal-footer {
  border-top: 1px solid #303030 !important;
}

/* ==========================================
   17. CHECKBOXES (Usados en el Drawer y Tablas)
   ========================================== */

/* Color del texto que acompaña al checkbox */
.dark-theme .ant-checkbox-wrapper,
.dark-theme .ant-checkbox-wrapper > span {
  color: #e0e0e0 !important;
}

/* Cuadro del checkbox sin marcar */
.dark-theme .ant-checkbox-inner {
  background-color: #141414 !important;
  border-color: #434343 !important;
}

/* Cuadro del checkbox al pasar el mouse */
.dark-theme .ant-checkbox-wrapper:hover .ant-checkbox-inner,
.dark-theme .ant-checkbox:hover .ant-checkbox-inner {
  border-color: #1677ff !important;
}

/* Checkbox deshabilitado */
.dark-theme .ant-checkbox-wrapper-disabled > span {
  color: #595959 !important;
}
.dark-theme .ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #262626 !important;
  border-color: #303030 !important;
}

/* ==========================================
   6. MENÚS DESPLEGABLES (SELECTS Y AUTOCOMPLETE)
   ========================================== */

/* Fondo del menú desplegable */
.dark-theme .ant-select-dropdown {
  background-color: #1f1f1f !important;
  border: 1px solid #303030 !important;
  padding: 4px !important;
}

/* Color del texto de las opciones */
.dark-theme .ant-select-item {
  color: #e0e0e0 !important;
}

/* Opción cuando pasas el mouse por encima (hover) */
.dark-theme .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background-color: #262626 !important;
}

/* Opción seleccionada (clicada) */
.dark-theme .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: #112a1d !important;
  color: #4ade80 !important;
}

/* Letras de "Empty" (cuando no hay datos en el select) */
.dark-theme .ant-empty-description {
  color: #8c8c8c !important;
}

/* ==========================================
   7. INPUT NUMBERS (Cantidades, Latitud, Longitud)
   ========================================== */
.dark-theme .ant-input-number,
.dark-theme .ant-input-number-affix-wrapper {
  background-color: #141414 !important;
  border-color: #434343 !important;
  color: #ffffff !important;
}

.dark-theme .ant-input-number-input {
  color: #ffffff !important;
  background-color: transparent !important;
}

/* Las flechitas de subir/bajar número */
.dark-theme .ant-input-number-handler-wrap {
  background-color: #1f1f1f !important;
  border-left-color: #434343 !important;
}
.dark-theme .ant-input-number-handler {
  border-color: #434343 !important;
}
.dark-theme .ant-input-number-handler-up-inner,
.dark-theme .ant-input-number-handler-down-inner {
  color: #a6a6a6 !important;
}

/* ==========================================
   8. BOTONES POR DEFECTO Y ELEMENTOS BLOQUEADOS
   ========================================== */
/* Botón "Cancelar" */
.dark-theme .ant-btn-default {
  background-color: #141414 !important;
  border-color: #434343 !important;
  color: #e0e0e0 !important;
}
.dark-theme .ant-btn-default:hover {
  background-color: #262626 !important;
  color: #ffffff !important;
  border-color: #177ddc !important; /* Un azul sutil al pasar el mouse */
}

/* Inputs en estado ReadOnly o Disabled */
.dark-theme .ant-input[readonly],
.dark-theme .ant-input-disabled {
  background-color: #262626 !important; /* Gris un poco más claro para denotar bloqueo */
  color: #8c8c8c !important;
  border-color: #303030 !important;
}

/* ==========================================
   11. TABLAS GLOBALES (Ant Design Tables) - REFORZADO
   ========================================== */

/* Limpiar fondos blancos ocultos en los contenedores de Ant Design */
.dark-theme .ant-table,
.dark-theme .ant-table-wrapper,
.dark-theme .ant-table-container,
.dark-theme .ant-table-content {
  background-color: transparent !important;
  color: #e0e0e0 !important;
}

/* Cabecera de la tabla (Gris un poco más claro para resaltar) */
.dark-theme .ant-table-thead > tr > th,
.dark-theme .ant-table-thead > tr > td {
  background-color: #1f1f1f !important;
  color: #ffffff !important;
  border-bottom: 1px solid #303030 !important;
}

/* Filas y celdas (El fondo que te estaba saliendo blanco) */
.dark-theme .ant-table-tbody > tr > td {
  background-color: #141414 !important; /* <--- Esto era lo que faltaba */
  color: #e0e0e0 !important;            /* <--- Color del texto claro */
  border-bottom: 1px solid #303030 !important;
}

/* Efecto Hover al pasar el mouse por las filas */
.dark-theme .ant-table-tbody > tr.ant-table-row:hover > td,
.dark-theme .ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background-color: #262626 !important;
}

/* Estado vacío de la tabla (Cuando no hay registros) */
.dark-theme .ant-table-empty .ant-table-placeholder,
.dark-theme .ant-table-empty .ant-table-placeholder:hover {
  background-color: #141414 !important;
  border-color: #303030 !important;
}

/* ==========================================
   FIX REFUERZO: CONTENEDOR INTERNO DEL HISTORIAL DETALLADO
   ========================================== */

/* 1. Atrapa el <div> o caja blanca que envuelve el historial y lo oscurece */
.dark-theme .ant-table-expanded-row > td > div,
.dark-theme .ant-table-expanded-row > td > div > div {
  background-color: #1f1f1f !important;
  border: 1px solid #303030 !important;
  border-radius: 8px !important;
  color: #e0e0e0 !important; /* Mueve el color de texto aquí para que herede de forma natural */
}

/* 2. CORREGIDO: Solo forzamos el color en títulos, EVITANDO usar "span" o "div" 
   para no matar el color rojo/verde de tus números y etiquetas. */
.dark-theme .ant-table-expanded-row > td p,
.dark-theme .ant-table-expanded-row > td h1,
.dark-theme .ant-table-expanded-row > td h2,
.dark-theme .ant-table-expanded-row > td h3,
.dark-theme .ant-table-expanded-row > td h4 {
  color: #e0e0e0 !important;
}

/* 3. Limpia el fondo de la sub-tabla interna para que se fusione con la caja oscura */
.dark-theme .ant-table-expanded-row .ant-table,
.dark-theme .ant-table-expanded-row .ant-table-container,
.dark-theme .ant-table-expanded-row .ant-table-wrapper {
  background-color: transparent !important;
}

/* 4. Cabecera específica de la sub-tabla (Fecha, Operación, N° Doc...) */
.dark-theme .ant-table-expanded-row .ant-table-thead > tr > th {
  background-color: #141414 !important; 
  border-bottom: 1px solid #303030 !important;
  color: #ffffff !important;
}

/* 5. FIX EXTRA: ETIQUETAS (TAGS) EN MODO OSCURO */
/* Ant Design pone fondos crema/rosa por defecto; los hacemos transparentes 
   para que solo se vea el borde y el texto de color sobre el fondo oscuro */
.dark-theme .ant-tag {
  background-color: transparent !important;
}

/* ==========================================
   12. BOTONES RADIO (Hoy, Semana, Mes, Año)
   ========================================== */
.dark-theme .ant-radio-button-wrapper {
  background-color: #141414 !important;
  border-color: #434343 !important;
  color: #e0e0e0 !important;
}

.dark-theme .ant-radio-button-wrapper-checked {
  background-color: #112a1d !important;
  border-color: #4ade80 !important;
  color: #4ade80 !important;
}

/* La línea separadora entre los botones radio */
.dark-theme .ant-radio-button-wrapper:not(:first-child)::before {
  background-color: #434343 !important;
}

/* ==========================================
   13. SELECTOR DE FECHAS (DatePicker / RangePicker)
   ========================================== */
/* El input donde se ven las fechas */
.dark-theme .ant-picker {
  background-color: #141414 !important;
  border-color: #434343 !important;
}

.dark-theme .ant-picker-input > input {
  color: #e0e0e0 !important;
}

.dark-theme .ant-picker-suffix,
.dark-theme .ant-picker-separator {
  color: #a6a6a6 !important;
}

/* El calendario flotante */
.dark-theme .ant-picker-panel-container {
  background-color: #1f1f1f !important;
  border: 1px solid #303030 !important;
}

.dark-theme .ant-picker-header,
.dark-theme .ant-picker-content th {
  color: #e0e0e0 !important;
  border-bottom-color: #303030 !important;
}

/* Los días dentro del calendario */
.dark-theme .ant-picker-cell {
  color: #a6a6a6 !important;
}
.dark-theme .ant-picker-cell-in-view {
  color: #e0e0e0 !important;
}
.dark-theme .ant-picker-cell-in-view:hover .ant-picker-cell-inner {
  background-color: #262626 !important;
}

/* ==========================================
   14. CONTENEDORES Y FONDOS DEL DASHBOARD
   ========================================== */
/* Fondo general por defecto (Modo Claro) */
.dashboard-main-container {
  padding: 24px;
  background-color: #f0f2f5;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
}
.dashboard-top-bar {
  background-color: white;
}
.inventario-card {
  background-color: #f0fdf4;
}
.inventario-title {
  color: #166534 !important;
}
.inventario-subtitle {
  color: #15803d !important;
}

/* Modo Oscuro para los contenedores */
.dark-theme .dashboard-main-container {
  background-color: transparent !important; /* Hereda el color oscuro de tu Layout principal */
}
.dark-theme .dashboard-top-bar {
  background-color: #141414 !important;
}
.dark-theme .inventario-card {
  background-color: #112a1d !important; /* Verde muy oscuro */
  border: 1px solid #166534 !important;
}
.dark-theme .inventario-title {
  color: #4ade80 !important; /* Verde neón claro para contrastar */
}
.dark-theme .inventario-subtitle {
  color: #86efac !important;
}

/* ==========================================
   9. PESTAÑAS (Tabs)
   ========================================== */
.dark-theme .ant-tabs {
  color: #e0e0e0 !important;
}
.dark-theme .ant-tabs-tab {
  color: #a6a6a6 !important;
}
.dark-theme .ant-tabs-tab:hover {
  color: #e0e0e0 !important;
}
.dark-theme .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #4ade80 !important; /* Verde estilo matriz/sistema */
}
.dark-theme .ant-tabs-ink-bar {
  background: #4ade80 !important;
}

/* ==========================================
   10. CAJAS PERSONALIZADAS (Contactos)
   ========================================== */
/* Comportamiento en Modo Claro (Por defecto) */
.custom-dashed-box {
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
}

/* Comportamiento en Modo Oscuro */
.dark-theme .custom-dashed-box {
  background-color: #141414 !important;
  border-color: #434343 !important;
}

/* ==========================================
   15. FIX PARA FOOTER Y RESUMEN DE TABLAS (EL CUADRO BLANCO)
   ========================================== */
.dark-theme .ant-table-footer,
.dark-theme .ant-table-summary,
.dark-theme tfoot.ant-table-summary > tr > td,
.dark-theme tfoot.ant-table-summary > tr > th,
.dark-theme .ant-table-summary-cell {
  background-color: #1f1f1f !important;
  color: #ffffff !important;
  border-bottom: 1px solid #303030 !important;
  border-top: 1px solid #303030 !important;
}

/* Si el texto dentro del cuadro tiene alguna clase de texto secundario, forzamos el color claro */
.dark-theme .ant-table-summary-cell span,
.dark-theme .ant-table-summary-cell strong,
.dark-theme .ant-table-footer span {
  color: #ffffff !important;
}

/* ==========================================
   18. TARJETAS DE ESTADÍSTICAS (Statistic)
   ========================================== */

/* Color del título para TODAS las tarjetas (se mantiene gris claro) */
.dark-theme .ant-statistic-title,
.dark-theme .ant-statistic-title span {
  color: #a6a6a6 !important;
}

/* SOLO forzar el color blanco a los números de la fila inferior */
.dark-theme .fila-conteos-blancos .ant-statistic-content-value,
.dark-theme .fila-conteos-blancos .ant-statistic-content-value-int,
.dark-theme .fila-conteos-blancos .ant-statistic-content-value-decimal {
  color: #ffffff !important;
}

/* ==========================================
   MÓDULO: VIEW SEARCH
   ========================================== */

/* --- COMPORTAMIENTO MODO CLARO (POR DEFECTO) --- */
.view-search-sider {
  background-color: #ffffff;
  border-right: 1px solid #f0f0f0;
}
.view-search-footer {
  background-color: #ffffff;
  border-top: 1px solid #f0f0f0;
}
.view-search-item {
  background-color: transparent;
  border: 1px solid transparent;
  transition: all 0.2s;
}
.view-search-item:hover {
  background-color: #fafafa;
}
.view-search-item.selected {
  background-color: #f0f9f6;
  border: 1px solid #b7eb8f;
}

/* --- COMPORTAMIENTO MODO OSCURO --- */
.dark-theme .view-search-sider {
  background-color: #1f1f1f !important;
  border-right-color: #303030 !important;
}
.dark-theme .view-search-footer {
  background-color: #1f1f1f !important;
  border-top-color: #303030 !important;
}
.dark-theme .view-search-title,
.dark-theme .view-search-item-title {
  color: #ffffff !important;
}
.dark-theme .view-search-item:hover {
  background-color: #262626 !important;
}
.dark-theme .view-search-item.selected {
  background-color: #112a1d !important;
  border-color: #1a4d2e !important;
}
/* ==========================================
   ADAPTACIÓN MODO OSCURO: SUPPLIER.CSS
   ========================================== */

/* 1. Limpiar el fondo general del layout futurista */
.dark-theme .futuristic-layout {
  background: transparent !important;
}

/* 2. Tarjeta principal futurista */
.dark-theme .futuristic-card {
  background: #1f1f1f !important;
  border-color: #303030 !important;
  box-shadow: none !important;
}

.dark-theme .futuristic-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;
}

/* 3. Panel de cristal (ESTE ES EL CAUSANTE DEL FONDO BLANCO EN LA IMAGEN) */
.dark-theme .glass-panel {
  background: #1f1f1f !important; /* Color de tarjeta oscura para que combine */
  border-color: #303030 !important;
  backdrop-filter: none; /* Opcional: mejora el rendimiento quitando el blur en oscuro */
}

/* 4. Inputs específicos del formulario futurista */
.dark-theme .futuristic-form .ant-input,
.dark-theme .futuristic-form .ant-input-number-input,
.dark-theme .futuristic-form .ant-select-selector {
  background-color: #141414 !important; /* Fondo de input oscuro */
  border-color: #434343 !important;
  color: #ffffff !important;
}

/* Mantener el glow verde/neón al hacer focus en los inputs, pero en modo oscuro */
.dark-theme .futuristic-form .ant-input:focus,
.dark-theme .futuristic-form .ant-input-focused,
.dark-theme .futuristic-form .ant-select-focused .ant-select-selector {
  box-shadow: 0 0 0 3px rgba(19, 194, 194, 0.2) !important;
  border-color: #13c2c2 !important;
}

/* Opcional: Asegurar que los placeholders de estos inputs no brillen demasiado */
.dark-theme .futuristic-form .ant-input::placeholder {
  color: #595959 !important;
}

/* ==========================================
   18. MÓDULO DE LOGIN (MODO OSCURO)
   ========================================== */

/* Fondo principal del Login (Sobreescribe el azul oscuro/gradiente por el fondo del sistema) */
.dark-theme .auth-main-bg {
  background-color: #141414 !important;
  background-image: none !important;
}

/* Tarjeta de Login (Glassmorphism oscuro) */
.dark-theme .auth-login-card {
  background: rgba(31, 31, 31, 0.85) !important;
  border: 1px solid #303030 !important;
}

/* Títulos principales */
.dark-theme .auth-title,
.dark-theme .auth-feature-title,
.dark-theme .auth-card-title {
  color: #ffffff !important;
}

/* Textos secundarios */
.dark-theme .auth-subtitle,
.dark-theme .auth-feature-desc,
.dark-theme .auth-card-text,
.dark-theme .auth-footer-text,
.dark-theme .auth-checkbox {
  color: #a6a6a6 !important;
}

/* Cajas de los íconos del panel izquierdo */
.dark-theme .auth-icon-box {
  background: #1f1f1f !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.5) !important;
}

/* Botón principal (Continuar) - Adaptado al verde de tu tema oscuro */
.dark-theme .auth-submit-btn {
  background: #112a1d !important;
  border-color: #1a4d2e !important;
  color: #4ade80 !important;
}
.dark-theme .auth-submit-btn:hover {
  background: #166534 !important;
  border-color: #166534 !important;
  color: #ffffff !important;
}

/* Enlaces (¿Olvidaste tu contraseña?, Solicitar acceso) */
.dark-theme .auth-link {
  color: #4ade80 !important;
}`, "",{"version":3,"sources":["webpack://./src/style/dark.css"],"names":[],"mappings":"IAAI;;;+CAG2C;;AAE/C,qCAAqC;AACrC;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;;;EAGE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D,uCAAuC,yBAAyB,EAAE,qBAAqB,EAAE;AACzF,gCAAgC,yBAAyB,EAAE,2BAA2B,EAAE;AACxF,uCAAuC,4BAA4B,EAAE;AACrE;;mCAEmC,cAAc,EAAE;AACnD,kCAAkC,cAAc,EAAE;AAClD,wCAAwC,yBAAyB,EAAE;AACnE,yCAAyC,yBAAyB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC3G,kDAAkD,cAAc,EAAE;AAClE,qCAAqC,yBAAyB,EAAE;AAChE,oCAAoC,yBAAyB,EAAE,cAAc,EAAE;AAC/E,sCAAsC,cAAc,EAAE;AACtD,6BAA6B,yBAAyB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AACjG,uCAAuC,4BAA4B,EAAE;AACrE,kCAAkC,yBAAyB,EAAE,qBAAqB,EAAE;AACpF,wCAAwC,qBAAqB,EAAE;AAC/D,qCAAqC,4BAA4B,EAAE;AACnE,qEAAqE,yBAAyB,EAAE;AAChG,oCAAoC,yBAAyB,EAAE,qBAAqB,EAAE;AACtF,mCAAmC,cAAc,EAAE;AACnD,oCAAoC,yBAAyB,EAAE,qBAAqB,EAAE;AACtF,0CAA0C,qBAAqB,EAAE;;AAEjE,8DAA8D;AAC9D,yCAAyC;;;;AAIzC;;+CAE+C;;AAE/C,gBAAgB;AAChB;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;;AAE/C,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;;EAEE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;;EAEE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,cAAc;AACd;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;;+CAE+C;;AAE/C,wBAAwB;AACxB;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;;;EAGE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;+CAE+C;;AAE/C,wCAAwC;AACxC;;;;EAIE,oCAAoC;EACpC,uCAAuC;EACvC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,qEAAqE;AACrE;EACE,wCAAwC;AAC1C;;AAEA;;+CAE+C;;AAE/C,6CAA6C;AAC7C;;EAEE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,0CAA0C;AAC1C;;EAEE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;+CAE+C;;AAE/C,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;AAC3B;;AAEA;;+CAE+C;AAC/C;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,wCAAwC;AACxC;EACE,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;;+CAE+C;AAC/C,qBAAqB;AACrB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC,EAAE,oCAAoC;AACxE;;AAEA,yCAAyC;AACzC;;EAEE,oCAAoC,EAAE,gDAAgD;EACtF,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;+CAE+C;;AAE/C,qEAAqE;AACrE;;;;EAIE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA,4DAA4D;AAC5D;EACE,oCAAoC,EAAE,iCAAiC;EACvE,yBAAyB,aAAa,+BAA+B;EACrE,2CAA2C;AAC7C;;AAEA,iDAAiD;AACjD;;EAEE,oCAAoC;AACtC;;AAEA,uDAAuD;AACvD;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;+CAE+C;;AAE/C,6EAA6E;AAC7E;;EAEE,oCAAoC;EACpC,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB,EAAE,kEAAkE;AAC/F;;AAEA;kEACkE;AAClE;;;;;EAKE,yBAAyB;AAC3B;;AAEA,sFAAsF;AACtF;;;EAGE,wCAAwC;AAC1C;;AAEA,yEAAyE;AACzE;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;4EAC4E;AAC5E;EACE,wCAAwC;AAC1C;;AAEA;;+CAE+C;AAC/C;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,oCAAoC;AACtC;;AAEA;;+CAE+C;AAC/C,qCAAqC;AACrC;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;;AAEA;;+CAE+C;AAC/C,2CAA2C;AAC3C;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,wCAAwC,EAAE,kDAAkD;AAC9F;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC,EAAE,qBAAqB;EAC3D,oCAAoC;AACtC;AACA;EACE,yBAAyB,EAAE,qCAAqC;AAClE;AACA;EACE,yBAAyB;AAC3B;;AAEA;;+CAE+C;AAC/C;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;AACA;EACE,8BAA8B;AAChC;;AAEA;;+CAE+C;AAC/C,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;+CAE+C;AAC/C;;;;;EAKE,oCAAoC;EACpC,yBAAyB;EACzB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA,kGAAkG;AAClG;;;EAGE,yBAAyB;AAC3B;;AAEA;;+CAE+C;;AAE/C,sEAAsE;AACtE;;EAEE,yBAAyB;AAC3B;;AAEA,kEAAkE;AAClE;;;EAGE,yBAAyB;AAC3B;;AAEA;;+CAE+C;;AAE/C,oDAAoD;AACpD;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;+CAE+C;;AAE/C,qDAAqD;AACrD;EACE,kCAAkC;AACpC;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;AACtD;;AAEA,4EAA4E;AAC5E;EACE,8BAA8B,EAAE,6CAA6C;EAC7E,gCAAgC;EAChC,qBAAqB,EAAE,+DAA+D;AACxF;;AAEA,mDAAmD;AACnD;;;EAGE,oCAAoC,EAAE,0BAA0B;EAChE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,kFAAkF;AAClF;;;EAGE,wDAAwD;EACxD,gCAAgC;AAClC;;AAEA,iFAAiF;AACjF;EACE,yBAAyB;AAC3B;;AAEA;;+CAE+C;;AAE/C,+FAA+F;AAC/F;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA,4CAA4C;AAC5C;EACE,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;;;EAGE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;;;;;EAKE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA,sEAAsE;AACtE;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB;AAC3B","sourcesContent":["    /* ==========================================\n   GLOBAL DARK THEME\n   Este archivo controla TODA la app en modo oscuro\n   ========================================== */\n\n/* 1. Fondo global de la aplicación */\nbody.dark-theme {\n  background-color: #141414;\n  color: #e0e0e0;\n}\n\n/* 2. Sobreescribir el Layout Principal y Sidebar (Ant Design) */\n.dark-theme .ant-layout,\n.dark-theme .ant-layout-sider,\n.dark-theme .ant-menu {\n  background-color: #1f1f1f !important;\n  color: #e0e0e0;\n}\n\n.dark-theme .ant-layout-sider {\n  border-right: 1px solid #303030;\n}\n\n.dark-theme .ant-menu-item-selected {\n  background-color: #112a1d !important;\n  color: #4ade80 !important;\n}\n\n/* 3. Tus estilos específicos de Configuración (Movidos aquí) */\n.dark-theme .settings-page-container { background-color: #141414; border-color: #303030; }\n.dark-theme .settings-sidebar { background-color: #1f1f1f; border-right-color: #303030; }\n.dark-theme .settings-sidebar-header { border-bottom-color: #303030; }\n.dark-theme .settings-sidebar-header h3,\n.dark-theme .settings-header-text h2,\n.dark-theme .settings-card-title { color: #ffffff; }\n.dark-theme .settings-menu-item { color: #a6a6a6; }\n.dark-theme .settings-menu-item:hover { background-color: #262626; }\n.dark-theme .settings-menu-item.active { background-color: #112a1d; color: #4ade80; border-color: #1a4d2e; }\n.dark-theme .settings-menu-item.active .anticon { color: #4ade80; }\n.dark-theme .settings-main-content { background-color: #141414; }\n.dark-theme .settings-header-icon { background-color: #112a45; color: #177ddc; }\n.dark-theme .settings-header-text p { color: #8c8c8c; }\n.dark-theme .settings-card { background-color: #1f1f1f; border-color: #303030; box-shadow: none; }\n.dark-theme .settings-section-header { border-bottom-color: #303030; }\n.dark-theme .payment-method-box { background-color: #1f1f1f; border-color: #303030; }\n.dark-theme .payment-method-box:hover { border-color: #434343; }\n.dark-theme .payment-method-header { border-bottom-color: #303030; }\n.dark-theme .payment-method-header span[style*=\"font-weight: 600\"] { color: #ffffff !important; }\n.dark-theme .payment-details-grid { background-color: #141414; border-color: #434343; }\n.dark-theme .payment-detail-item { color: #e0e0e0; }\n.dark-theme .image-upload-wrapper { background-color: #141414; border-color: #434343; }\n.dark-theme .image-upload-wrapper:hover { border-color: #177ddc; }\n\n/* 4. Aquí irás agregando cualquier otro módulo en el futuro */\n/* .dark-theme .modulo-facturas { ... } */\n\n\n\n/* ==========================================\n   SISTEMA DE TEMA OSCURO GLOBAL (dark.css)\n   ========================================== */\n\n/* Base Global */\nbody.dark-theme {\n  background-color: #141414 !important;\n  color: #ffffff !important;\n}\n\n/* --- MÓDULO CONFIGURACIÓN EN MODO OSCURO --- */\n.dark-theme .settings-page-container {\n  background-color: #141414;\n}\n\n.dark-theme .settings-sidebar {\n  background-color: #1f1f1f;\n  border-right-color: #303030;\n}\n\n.dark-theme .settings-sidebar-header {\n  border-bottom-color: #303030;\n}\n\n.dark-theme .settings-sidebar-header h3,\n.dark-theme .settings-header-text h2,\n.dark-theme .settings-card-title {\n  color: #ffffff;\n}\n\n.dark-theme .settings-menu-item {\n  color: #a6a6a6;\n}\n\n.dark-theme .settings-menu-item:hover {\n  background-color: #262626;\n}\n\n.dark-theme .settings-menu-item.active {\n  background-color: #112a1d; \n  color: #4ade80;\n  border-color: #1a4d2e;\n}\n\n.dark-theme .settings-menu-item.active .anticon {\n  color: #4ade80;\n}\n\n.dark-theme .settings-main-content {\n  background-color: #141414;\n}\n\n.dark-theme .settings-header-icon {\n  background-color: #112a45;\n  color: #177ddc;\n}\n\n.dark-theme .settings-header-text p {\n  color: #8c8c8c;\n}\n\n.dark-theme .settings-card {\n  background-color: #1f1f1f;\n  border-color: #303030;\n  box-shadow: none;\n}\n\n.dark-theme .settings-section-header {\n  border-bottom-color: #303030;\n}\n\n.dark-theme .payment-method-box {\n  background-color: #1f1f1f;\n  border-color: #303030;\n}\n\n.dark-theme .payment-method-box:hover {\n  border-color: #434343;\n}\n\n.dark-theme .payment-method-header {\n  border-bottom-color: #303030;\n}\n\n.dark-theme .payment-method-header span[style*=\"font-weight: 600\"] {\n  color: #ffffff !important;\n}\n\n.dark-theme .payment-details-grid {\n  background-color: #141414;\n  border-color: #434343;\n}\n\n.dark-theme .payment-detail-item {\n  color: #e0e0e0;\n}\n\n.dark-theme .image-upload-wrapper {\n  background-color: #141414;\n  border-color: #434343;\n}\n\n.dark-theme .image-upload-wrapper:hover {\n  border-color: #177ddc;\n}\n\n.dark-theme .empty-text {\n  color: #a6a6a6;\n}\n\n/* --- REGLAS ANT DESIGN PARA MODO OSCURO --- */\n\n/* Labels de Formularios */\n.dark-theme .ant-form-item-label > label {\n  color: #ffffff !important; \n}\n\n/* Inputs, Textareas y Selects */\n.dark-theme .ant-input,\n.dark-theme .ant-select-selector,\n.dark-theme .ant-input-textarea {\n  background-color: #141414 !important;\n  color: #ffffff !important;\n  border-color: #434343 !important;\n}\n\n/* Placeholders */\n.dark-theme .ant-input::placeholder,\n.dark-theme .ant-select-selection-placeholder {\n  color: #595959 !important;\n}\n\n/* Iconos de Selects */\n.dark-theme .ant-select-arrow,\n.dark-theme .ant-select-clear {\n  color: #a6a6a6 !important;\n}\n\n/* Modales */\n.dark-theme .ant-modal-content,\n.dark-theme .ant-modal-header {\n  background-color: #1f1f1f !important;\n}\n.dark-theme .ant-modal-title {\n  color: #ffffff !important;\n}\n.dark-theme .ant-modal-close {\n  color: #a6a6a6 !important;\n}\n.dark-theme .ant-modal-close:hover {\n  color: #ffffff !important;\n  background-color: #303030 !important;\n}\n\n/* Divisores */\n.dark-theme .ant-divider-inner-text {\n  color: #ffffff;\n}\n.dark-theme .ant-divider-dashed {\n  border-color: #434343;\n}\n\n/* Responsividad Móvil */\n@media (max-width: 768px) {\n  .dark-theme .settings-sidebar {\n    border-bottom-color: #303030;\n  }\n}\n/* ==========================================\n   COMPONENTES GENERALES DE ANTD (MODO OSCURO)\n   ========================================== */\n\n/* 1. TARJETAS (Cards) */\n.dark-theme .ant-card {\n  background-color: #1f1f1f !important;\n  border-color: #303030 !important;\n}\n\n.dark-theme .ant-card-head {\n  border-bottom-color: #303030 !important;\n}\n\n.dark-theme .ant-card-head-title,\n.dark-theme .ant-card-head-title .ant-typography {\n  color: #ffffff !important;\n}\n\n/* 2. INPUTS Y CAMPOS DE TEXTO */\n.dark-theme .ant-input,\n.dark-theme .ant-input-affix-wrapper,\n.dark-theme .ant-input-search-button {\n  background-color: #141414 !important;\n  border-color: #434343 !important;\n  color: #ffffff !important;\n}\n\n.dark-theme .ant-input::placeholder,\n.dark-theme .ant-input-affix-wrapper input::placeholder {\n  color: #8c8c8c !important;\n}\n\n.dark-theme .ant-input-search .ant-input-group-addon button {\n  background-color: #262626 !important;\n  border-color: #434343 !important;\n  color: #ffffff !important;\n}\n\n/* 3. ETIQUETAS DE FORMULARIO Y TEXTO GENERAL */\n.dark-theme label,\n.dark-theme .ant-form-item-label > label,\n.dark-theme .ant-typography {\n  color: #e0e0e0 !important;\n}\n\n/* 4. DIVIDERS (LÍNEAS DIVISORAS) */\n.dark-theme .ant-divider {\n  border-top-color: #303030 !important;\n}\n\n/* 5. POPCONFIRM / MODALES */\n.dark-theme .ant-popover-inner,\n.dark-theme .ant-popconfirm-inner-content {\n  background-color: #1f1f1f !important;\n  color: #ffffff !important;\n}\n.dark-theme .ant-popover-message-title {\n  color: #ffffff !important;\n}\n/* ==========================================\n   16. DRAWERS (PANELES LATERALES) Y MODALES (PORTALES)\n   ========================================== */\n\n/* Contenedores principales del Drawer */\n.dark-theme .ant-drawer-content,\n.dark-theme .ant-drawer-header,\n.dark-theme .ant-drawer-body,\n.dark-theme .ant-drawer-footer {\n  background-color: #1f1f1f !important;\n  border-bottom-color: #303030 !important;\n  border-top-color: #303030 !important;\n  color: #e0e0e0 !important;\n}\n\n/* Título y botón de cerrar del Drawer */\n.dark-theme .ant-drawer-title {\n  color: #ffffff !important;\n}\n.dark-theme .ant-drawer-close {\n  color: #a6a6a6 !important;\n}\n.dark-theme .ant-drawer-close:hover {\n  color: #ffffff !important;\n  background-color: #303030 !important;\n}\n\n/* Footer del Modal (Faltaba oscurecer la línea divisoria inferior) */\n.dark-theme .ant-modal-footer {\n  border-top: 1px solid #303030 !important;\n}\n\n/* ==========================================\n   17. CHECKBOXES (Usados en el Drawer y Tablas)\n   ========================================== */\n\n/* Color del texto que acompaña al checkbox */\n.dark-theme .ant-checkbox-wrapper,\n.dark-theme .ant-checkbox-wrapper > span {\n  color: #e0e0e0 !important;\n}\n\n/* Cuadro del checkbox sin marcar */\n.dark-theme .ant-checkbox-inner {\n  background-color: #141414 !important;\n  border-color: #434343 !important;\n}\n\n/* Cuadro del checkbox al pasar el mouse */\n.dark-theme .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.dark-theme .ant-checkbox:hover .ant-checkbox-inner {\n  border-color: #1677ff !important;\n}\n\n/* Checkbox deshabilitado */\n.dark-theme .ant-checkbox-wrapper-disabled > span {\n  color: #595959 !important;\n}\n.dark-theme .ant-checkbox-disabled .ant-checkbox-inner {\n  background-color: #262626 !important;\n  border-color: #303030 !important;\n}\n\n/* ==========================================\n   6. MENÚS DESPLEGABLES (SELECTS Y AUTOCOMPLETE)\n   ========================================== */\n\n/* Fondo del menú desplegable */\n.dark-theme .ant-select-dropdown {\n  background-color: #1f1f1f !important;\n  border: 1px solid #303030 !important;\n  padding: 4px !important;\n}\n\n/* Color del texto de las opciones */\n.dark-theme .ant-select-item {\n  color: #e0e0e0 !important;\n}\n\n/* Opción cuando pasas el mouse por encima (hover) */\n.dark-theme .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n  background-color: #262626 !important;\n}\n\n/* Opción seleccionada (clicada) */\n.dark-theme .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n  background-color: #112a1d !important;\n  color: #4ade80 !important;\n}\n\n/* Letras de \"Empty\" (cuando no hay datos en el select) */\n.dark-theme .ant-empty-description {\n  color: #8c8c8c !important;\n}\n\n/* ==========================================\n   7. INPUT NUMBERS (Cantidades, Latitud, Longitud)\n   ========================================== */\n.dark-theme .ant-input-number,\n.dark-theme .ant-input-number-affix-wrapper {\n  background-color: #141414 !important;\n  border-color: #434343 !important;\n  color: #ffffff !important;\n}\n\n.dark-theme .ant-input-number-input {\n  color: #ffffff !important;\n  background-color: transparent !important;\n}\n\n/* Las flechitas de subir/bajar número */\n.dark-theme .ant-input-number-handler-wrap {\n  background-color: #1f1f1f !important;\n  border-left-color: #434343 !important;\n}\n.dark-theme .ant-input-number-handler {\n  border-color: #434343 !important;\n}\n.dark-theme .ant-input-number-handler-up-inner,\n.dark-theme .ant-input-number-handler-down-inner {\n  color: #a6a6a6 !important;\n}\n\n/* ==========================================\n   8. BOTONES POR DEFECTO Y ELEMENTOS BLOQUEADOS\n   ========================================== */\n/* Botón \"Cancelar\" */\n.dark-theme .ant-btn-default {\n  background-color: #141414 !important;\n  border-color: #434343 !important;\n  color: #e0e0e0 !important;\n}\n.dark-theme .ant-btn-default:hover {\n  background-color: #262626 !important;\n  color: #ffffff !important;\n  border-color: #177ddc !important; /* Un azul sutil al pasar el mouse */\n}\n\n/* Inputs en estado ReadOnly o Disabled */\n.dark-theme .ant-input[readonly],\n.dark-theme .ant-input-disabled {\n  background-color: #262626 !important; /* Gris un poco más claro para denotar bloqueo */\n  color: #8c8c8c !important;\n  border-color: #303030 !important;\n}\n\n/* ==========================================\n   11. TABLAS GLOBALES (Ant Design Tables) - REFORZADO\n   ========================================== */\n\n/* Limpiar fondos blancos ocultos en los contenedores de Ant Design */\n.dark-theme .ant-table,\n.dark-theme .ant-table-wrapper,\n.dark-theme .ant-table-container,\n.dark-theme .ant-table-content {\n  background-color: transparent !important;\n  color: #e0e0e0 !important;\n}\n\n/* Cabecera de la tabla (Gris un poco más claro para resaltar) */\n.dark-theme .ant-table-thead > tr > th,\n.dark-theme .ant-table-thead > tr > td {\n  background-color: #1f1f1f !important;\n  color: #ffffff !important;\n  border-bottom: 1px solid #303030 !important;\n}\n\n/* Filas y celdas (El fondo que te estaba saliendo blanco) */\n.dark-theme .ant-table-tbody > tr > td {\n  background-color: #141414 !important; /* <--- Esto era lo que faltaba */\n  color: #e0e0e0 !important;            /* <--- Color del texto claro */\n  border-bottom: 1px solid #303030 !important;\n}\n\n/* Efecto Hover al pasar el mouse por las filas */\n.dark-theme .ant-table-tbody > tr.ant-table-row:hover > td,\n.dark-theme .ant-table-tbody > tr > td.ant-table-cell-row-hover {\n  background-color: #262626 !important;\n}\n\n/* Estado vacío de la tabla (Cuando no hay registros) */\n.dark-theme .ant-table-empty .ant-table-placeholder,\n.dark-theme .ant-table-empty .ant-table-placeholder:hover {\n  background-color: #141414 !important;\n  border-color: #303030 !important;\n}\n\n/* ==========================================\n   FIX REFUERZO: CONTENEDOR INTERNO DEL HISTORIAL DETALLADO\n   ========================================== */\n\n/* 1. Atrapa el <div> o caja blanca que envuelve el historial y lo oscurece */\n.dark-theme .ant-table-expanded-row > td > div,\n.dark-theme .ant-table-expanded-row > td > div > div {\n  background-color: #1f1f1f !important;\n  border: 1px solid #303030 !important;\n  border-radius: 8px !important;\n  color: #e0e0e0 !important; /* Mueve el color de texto aquí para que herede de forma natural */\n}\n\n/* 2. CORREGIDO: Solo forzamos el color en títulos, EVITANDO usar \"span\" o \"div\" \n   para no matar el color rojo/verde de tus números y etiquetas. */\n.dark-theme .ant-table-expanded-row > td p,\n.dark-theme .ant-table-expanded-row > td h1,\n.dark-theme .ant-table-expanded-row > td h2,\n.dark-theme .ant-table-expanded-row > td h3,\n.dark-theme .ant-table-expanded-row > td h4 {\n  color: #e0e0e0 !important;\n}\n\n/* 3. Limpia el fondo de la sub-tabla interna para que se fusione con la caja oscura */\n.dark-theme .ant-table-expanded-row .ant-table,\n.dark-theme .ant-table-expanded-row .ant-table-container,\n.dark-theme .ant-table-expanded-row .ant-table-wrapper {\n  background-color: transparent !important;\n}\n\n/* 4. Cabecera específica de la sub-tabla (Fecha, Operación, N° Doc...) */\n.dark-theme .ant-table-expanded-row .ant-table-thead > tr > th {\n  background-color: #141414 !important; \n  border-bottom: 1px solid #303030 !important;\n  color: #ffffff !important;\n}\n\n/* 5. FIX EXTRA: ETIQUETAS (TAGS) EN MODO OSCURO */\n/* Ant Design pone fondos crema/rosa por defecto; los hacemos transparentes \n   para que solo se vea el borde y el texto de color sobre el fondo oscuro */\n.dark-theme .ant-tag {\n  background-color: transparent !important;\n}\n\n/* ==========================================\n   12. BOTONES RADIO (Hoy, Semana, Mes, Año)\n   ========================================== */\n.dark-theme .ant-radio-button-wrapper {\n  background-color: #141414 !important;\n  border-color: #434343 !important;\n  color: #e0e0e0 !important;\n}\n\n.dark-theme .ant-radio-button-wrapper-checked {\n  background-color: #112a1d !important;\n  border-color: #4ade80 !important;\n  color: #4ade80 !important;\n}\n\n/* La línea separadora entre los botones radio */\n.dark-theme .ant-radio-button-wrapper:not(:first-child)::before {\n  background-color: #434343 !important;\n}\n\n/* ==========================================\n   13. SELECTOR DE FECHAS (DatePicker / RangePicker)\n   ========================================== */\n/* El input donde se ven las fechas */\n.dark-theme .ant-picker {\n  background-color: #141414 !important;\n  border-color: #434343 !important;\n}\n\n.dark-theme .ant-picker-input > input {\n  color: #e0e0e0 !important;\n}\n\n.dark-theme .ant-picker-suffix,\n.dark-theme .ant-picker-separator {\n  color: #a6a6a6 !important;\n}\n\n/* El calendario flotante */\n.dark-theme .ant-picker-panel-container {\n  background-color: #1f1f1f !important;\n  border: 1px solid #303030 !important;\n}\n\n.dark-theme .ant-picker-header,\n.dark-theme .ant-picker-content th {\n  color: #e0e0e0 !important;\n  border-bottom-color: #303030 !important;\n}\n\n/* Los días dentro del calendario */\n.dark-theme .ant-picker-cell {\n  color: #a6a6a6 !important;\n}\n.dark-theme .ant-picker-cell-in-view {\n  color: #e0e0e0 !important;\n}\n.dark-theme .ant-picker-cell-in-view:hover .ant-picker-cell-inner {\n  background-color: #262626 !important;\n}\n\n/* ==========================================\n   14. CONTENEDORES Y FONDOS DEL DASHBOARD\n   ========================================== */\n/* Fondo general por defecto (Modo Claro) */\n.dashboard-main-container {\n  padding: 24px;\n  background-color: #f0f2f5;\n  min-height: 100vh;\n  width: 100%;\n  overflow-x: hidden;\n}\n.dashboard-top-bar {\n  background-color: white;\n}\n.inventario-card {\n  background-color: #f0fdf4;\n}\n.inventario-title {\n  color: #166534 !important;\n}\n.inventario-subtitle {\n  color: #15803d !important;\n}\n\n/* Modo Oscuro para los contenedores */\n.dark-theme .dashboard-main-container {\n  background-color: transparent !important; /* Hereda el color oscuro de tu Layout principal */\n}\n.dark-theme .dashboard-top-bar {\n  background-color: #141414 !important;\n}\n.dark-theme .inventario-card {\n  background-color: #112a1d !important; /* Verde muy oscuro */\n  border: 1px solid #166534 !important;\n}\n.dark-theme .inventario-title {\n  color: #4ade80 !important; /* Verde neón claro para contrastar */\n}\n.dark-theme .inventario-subtitle {\n  color: #86efac !important;\n}\n\n/* ==========================================\n   9. PESTAÑAS (Tabs)\n   ========================================== */\n.dark-theme .ant-tabs {\n  color: #e0e0e0 !important;\n}\n.dark-theme .ant-tabs-tab {\n  color: #a6a6a6 !important;\n}\n.dark-theme .ant-tabs-tab:hover {\n  color: #e0e0e0 !important;\n}\n.dark-theme .ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #4ade80 !important; /* Verde estilo matriz/sistema */\n}\n.dark-theme .ant-tabs-ink-bar {\n  background: #4ade80 !important;\n}\n\n/* ==========================================\n   10. CAJAS PERSONALIZADAS (Contactos)\n   ========================================== */\n/* Comportamiento en Modo Claro (Por defecto) */\n.custom-dashed-box {\n  background-color: #fafafa;\n  border: 1px dashed #d9d9d9;\n}\n\n/* Comportamiento en Modo Oscuro */\n.dark-theme .custom-dashed-box {\n  background-color: #141414 !important;\n  border-color: #434343 !important;\n}\n\n/* ==========================================\n   15. FIX PARA FOOTER Y RESUMEN DE TABLAS (EL CUADRO BLANCO)\n   ========================================== */\n.dark-theme .ant-table-footer,\n.dark-theme .ant-table-summary,\n.dark-theme tfoot.ant-table-summary > tr > td,\n.dark-theme tfoot.ant-table-summary > tr > th,\n.dark-theme .ant-table-summary-cell {\n  background-color: #1f1f1f !important;\n  color: #ffffff !important;\n  border-bottom: 1px solid #303030 !important;\n  border-top: 1px solid #303030 !important;\n}\n\n/* Si el texto dentro del cuadro tiene alguna clase de texto secundario, forzamos el color claro */\n.dark-theme .ant-table-summary-cell span,\n.dark-theme .ant-table-summary-cell strong,\n.dark-theme .ant-table-footer span {\n  color: #ffffff !important;\n}\n\n/* ==========================================\n   18. TARJETAS DE ESTADÍSTICAS (Statistic)\n   ========================================== */\n\n/* Color del título para TODAS las tarjetas (se mantiene gris claro) */\n.dark-theme .ant-statistic-title,\n.dark-theme .ant-statistic-title span {\n  color: #a6a6a6 !important;\n}\n\n/* SOLO forzar el color blanco a los números de la fila inferior */\n.dark-theme .fila-conteos-blancos .ant-statistic-content-value,\n.dark-theme .fila-conteos-blancos .ant-statistic-content-value-int,\n.dark-theme .fila-conteos-blancos .ant-statistic-content-value-decimal {\n  color: #ffffff !important;\n}\n\n/* ==========================================\n   MÓDULO: VIEW SEARCH\n   ========================================== */\n\n/* --- COMPORTAMIENTO MODO CLARO (POR DEFECTO) --- */\n.view-search-sider {\n  background-color: #ffffff;\n  border-right: 1px solid #f0f0f0;\n}\n.view-search-footer {\n  background-color: #ffffff;\n  border-top: 1px solid #f0f0f0;\n}\n.view-search-item {\n  background-color: transparent;\n  border: 1px solid transparent;\n  transition: all 0.2s;\n}\n.view-search-item:hover {\n  background-color: #fafafa;\n}\n.view-search-item.selected {\n  background-color: #f0f9f6;\n  border: 1px solid #b7eb8f;\n}\n\n/* --- COMPORTAMIENTO MODO OSCURO --- */\n.dark-theme .view-search-sider {\n  background-color: #1f1f1f !important;\n  border-right-color: #303030 !important;\n}\n.dark-theme .view-search-footer {\n  background-color: #1f1f1f !important;\n  border-top-color: #303030 !important;\n}\n.dark-theme .view-search-title,\n.dark-theme .view-search-item-title {\n  color: #ffffff !important;\n}\n.dark-theme .view-search-item:hover {\n  background-color: #262626 !important;\n}\n.dark-theme .view-search-item.selected {\n  background-color: #112a1d !important;\n  border-color: #1a4d2e !important;\n}\n/* ==========================================\n   ADAPTACIÓN MODO OSCURO: SUPPLIER.CSS\n   ========================================== */\n\n/* 1. Limpiar el fondo general del layout futurista */\n.dark-theme .futuristic-layout {\n  background: transparent !important;\n}\n\n/* 2. Tarjeta principal futurista */\n.dark-theme .futuristic-card {\n  background: #1f1f1f !important;\n  border-color: #303030 !important;\n  box-shadow: none !important;\n}\n\n.dark-theme .futuristic-card:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;\n}\n\n/* 3. Panel de cristal (ESTE ES EL CAUSANTE DEL FONDO BLANCO EN LA IMAGEN) */\n.dark-theme .glass-panel {\n  background: #1f1f1f !important; /* Color de tarjeta oscura para que combine */\n  border-color: #303030 !important;\n  backdrop-filter: none; /* Opcional: mejora el rendimiento quitando el blur en oscuro */\n}\n\n/* 4. Inputs específicos del formulario futurista */\n.dark-theme .futuristic-form .ant-input,\n.dark-theme .futuristic-form .ant-input-number-input,\n.dark-theme .futuristic-form .ant-select-selector {\n  background-color: #141414 !important; /* Fondo de input oscuro */\n  border-color: #434343 !important;\n  color: #ffffff !important;\n}\n\n/* Mantener el glow verde/neón al hacer focus en los inputs, pero en modo oscuro */\n.dark-theme .futuristic-form .ant-input:focus,\n.dark-theme .futuristic-form .ant-input-focused,\n.dark-theme .futuristic-form .ant-select-focused .ant-select-selector {\n  box-shadow: 0 0 0 3px rgba(19, 194, 194, 0.2) !important;\n  border-color: #13c2c2 !important;\n}\n\n/* Opcional: Asegurar que los placeholders de estos inputs no brillen demasiado */\n.dark-theme .futuristic-form .ant-input::placeholder {\n  color: #595959 !important;\n}\n\n/* ==========================================\n   18. MÓDULO DE LOGIN (MODO OSCURO)\n   ========================================== */\n\n/* Fondo principal del Login (Sobreescribe el azul oscuro/gradiente por el fondo del sistema) */\n.dark-theme .auth-main-bg {\n  background-color: #141414 !important;\n  background-image: none !important;\n}\n\n/* Tarjeta de Login (Glassmorphism oscuro) */\n.dark-theme .auth-login-card {\n  background: rgba(31, 31, 31, 0.85) !important;\n  border: 1px solid #303030 !important;\n}\n\n/* Títulos principales */\n.dark-theme .auth-title,\n.dark-theme .auth-feature-title,\n.dark-theme .auth-card-title {\n  color: #ffffff !important;\n}\n\n/* Textos secundarios */\n.dark-theme .auth-subtitle,\n.dark-theme .auth-feature-desc,\n.dark-theme .auth-card-text,\n.dark-theme .auth-footer-text,\n.dark-theme .auth-checkbox {\n  color: #a6a6a6 !important;\n}\n\n/* Cajas de los íconos del panel izquierdo */\n.dark-theme .auth-icon-box {\n  background: #1f1f1f !important;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.5) !important;\n}\n\n/* Botón principal (Continuar) - Adaptado al verde de tu tema oscuro */\n.dark-theme .auth-submit-btn {\n  background: #112a1d !important;\n  border-color: #1a4d2e !important;\n  color: #4ade80 !important;\n}\n.dark-theme .auth-submit-btn:hover {\n  background: #166534 !important;\n  border-color: #166534 !important;\n  color: #ffffff !important;\n}\n\n/* Enlaces (¿Olvidaste tu contraseña?, Solicitar acceso) */\n.dark-theme .auth-link {\n  color: #4ade80 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
